<template>
  <section class="raw-ask-view">
    <div class="raw-ask-view__banner">
      <p class="raw-ask-view__title">Raw test mode</p>
      <p class="raw-ask-view__text">
        Showing the model's response exactly as returned — no report formatting applied.
      </p>
    </div>

    <pre class="raw-ask-view__text-body">{{ answer }}</pre>
  </section>
</template>

<script>
export default {
  name: 'RawAskView',
  props: {
    answer: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.raw-ask-view {
  display: flex;
  flex-direction: column;
  gap: $space-4;
}

.raw-ask-view__banner {
  border: 1px solid $color-border;
  border-radius: $radius-md;
  background: $color-surface-alt;
  padding: $space-3;
}

.raw-ask-view__title,
.raw-ask-view__text {
  margin: 0;
}

.raw-ask-view__title {
  font-weight: 700;
  color: $color-text-strong;
}

.raw-ask-view__text {
  margin-top: $space-1;
  color: $color-text-muted;
}

.raw-ask-view__text-body {
  margin: 0;
  padding: $space-4;
  border: 1px solid $color-border;
  border-radius: $radius-md;
  background: $color-surface;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: $font-size-sm;
  line-height: 1.6;
  color: $color-text;
}
</style>
